export default __webpack_public_path__ + "static/media/chat1.70eec155.png";